import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import styled from "styled-components";
import Button from "sushiweb/Button";
import { useLocation } from "react-router-dom";

const InputBar = (props) => {
  const stateObj = {
    delivery_trip_id: undefined,
    external_order_id: undefined,
  };

  const location = useLocation();
  const [inputText, setInputText] = useState({ ...stateObj });

  const { handleSubmit } = props;

  const onChange = (val, key) => {
    const state = { ...stateObj };

    setInputText({
      ...state,
      [key]: val,
    });
  };

  const onSubmit = (evt) => {
    evt.preventDefault();
    handleSubmit(inputText);
  };

  useEffect(() => {
    const state = { ...stateObj };

    let stateChangeFlag = false;
    const searchQueryParams = location.search;
    const paramsObject = new URLSearchParams(searchQueryParams);
    if (paramsObject.has("delivery_trip_id")) {
      state["delivery_trip_id"] = paramsObject.get("delivery_trip_id");
      stateChangeFlag = true;
    } else if (paramsObject.has("external_order_id")) {
      state["external_order_id"] = paramsObject.get("external_order_id");
      stateChangeFlag = true;
    }

    if (stateChangeFlag) {
      setInputText(state);
      handleSubmit(state);
    }
  }, []);

  return (
    <InputBarFormContainer className="actionBar flex items-start">
      <Input
        className="mr-10"
        fullWidth={false}
        value={inputText.delivery_trip_id}
        autoFocus={true}
        label="Delivery Trip ID"
        data-testid="deliveryTripIdInput"
        onChange={(val) => onChange(val, "delivery_trip_id")}
        id="sushi-input"
      />
      <div className="self-baseline mr-10">OR</div>
      <Input
        id="sushi-input"
        className="mr-10"
        fullWidth={false}
        value={inputText.external_order_id}
        data-testid="externalOrderIdInput"
        label="External Order ID"
        onChange={(val) => onChange(val, "external_order_id")}
      />
      <Button
        className="sushi-btn"
        appearance="outline"
        data-testid="tripStatisticsSubmitBtn"
        onClick={onSubmit}
      >
        Search
      </Button>
    </InputBarFormContainer>
  );
};

const InputBarFormContainer = styled.div``;

export default InputBar;
